// dependencies
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, getMatchedRouteKeyValue } from "yarrr";

// components

// selectors

// actions

// css
import css from "./Navigation";

const Navigation = (props) => {
	const { companyID, activeView } = props;

	const navigation = [
		{ name: "snapshot", label: "Snapshot", href: `/companies/${companyID}/snapshot` },
		{ name: "feature-flags", label: "Feature Flags", href: `/companies/${companyID}/feature-flags` },
		{ name: "employees", label: "Employees", href: `/companies/${companyID}/employees` },
		{ name: "invoices", label: "Invoices", href: `/companies/${companyID}/invoices` },
		{ name: "deleted-objects", label: "Deleted Objects", href: `/companies/${companyID}/deleted-objects` },
		{ name: "access-controls", label: "Access", href: `/companies/${companyID}/access-controls` },
		{ name: "bulk-email-change", label: "Bulk Email Change", href: `/companies/${companyID}/bulk-email-change` },
		{ name: "engagement-settings-logs", label: "Engagement Logs", href: `/companies/${companyID}/engagement-settings-logs` },
	];

	return (
		<div className={css.main}>
			<div testid="wrapper" className={css.navigationItems}>
				{navigation.map((item) => {
					const isActive = activeView === item.name;

					return (
						<Link
							key={item.name}
							href={item.href}
							className={`${css.navigationItem} ${isActive ? css.isActive : ""}`}
						>
							{item.label}
						</Link>
					);
				})}
			</div>
		</div>
	);
};

Navigation.propTypes = {
	activeView: PropTypes.string.isRequired,
	companyID: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
	const view = getMatchedRouteKeyValue(state, "view");
	const companyID = getMatchedRouteKeyValue(state, "companyID");

	return {
		companyID,
		activeView: view || "snapshot",
	};
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
